import { useContext, useEffect, useRef, useState } from "react";

import { DiscoveryContext } from "../discovery-context";
import ErrorView from "./../../../Component/ErrorView/ErrorView";
import BrandSpecItem from "./../BrandSpecItem/BrandSpecItem";
import classes from "./BrandSnippets.module.css";

let failedLLMIndexes = [];

const THEMES = [
  // {
  //   id: 1,
  //   name: "GPT-4o",
  //   llm: "gpt-4o",
  //   url: "/llm-execute",
  //   img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
  //   text: "",
  // },

  {
    id: 2,
    name: "GPT-5",
    llm: "gpt-5",
    url: "/llm-execute",
    img: "https://cdn.oaistatic.com/assets/apple-touch-icon-mz9nytnj.webp",
    text: "",
  },
  {
    id: 3,
    name: "Gemini",
    llm: "GeminiV25",
    url: "/llm-execute",
    img: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
    text: "",
  },
  {
    id: 4,
    name: "Claude",
    llm: "Claude4",
    url: "/llm-execute",
    img: "https://claude.ai/images/claude_app_icon.png",
    text: "",
  },
  {
    id: 5,
    name: "Llama",
    llm: "llama3",
    url: "/llm-execute",
    img: "https://static.xx.fbcdn.net/rsrc.php/y5/r/m4nf26cLQxS.ico",
    text: "",
  },
  {
    id: 5,
    name: "Perplexity (sonar)",
    llm: "Perplexity",
    url: "/llm-execute",
    img: "https://mintlify.s3-us-west-1.amazonaws.com/perplexity/_generated/favicon/favicon-32x32.png?v=3",
    text: "",
  },
];

export default function BrandSnippets({ entity, category, llm }) {
  const [error, setError] = useState();
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryType = discoveryCtx.type || "brand";
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (discoveryCtx?.brand_themes[llm][category]?.length > 0) return;

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [discoveryCtx?.brand_themes[llm][category]?.length]);


  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);


let brandSnippets = [...THEMES].filter((_, i) => !failedLLMIndexes.includes(i));
let brand_themes = discoveryCtx?.brand_themes[llm][category];
let loading = true;

if (brand_themes && brand_themes.length > 0) {

  brand_themes.forEach((theme, index) => {

    let llmName = null;
    let dataList = [];

    if (theme && typeof theme === "object" && !Array.isArray(theme)) {
      llmName = theme.llm ?? null;
      dataList = theme.data ?? [];
    }

    else if (Array.isArray(theme)) {
      dataList = theme;      
    }

    let snippet = null;

    if (llmName) {
      snippet = brandSnippets.find((s) => s.llm === llmName);
    } else {
      snippet = brandSnippets[index]; 
    }

    if (snippet && dataList.length > 0) {
      snippet.text = dataList
        .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
        .join(", ");
    }
  });

  loading = false;
}

  return (
    <div className={classes.container}>
      {brandSnippets.length > 0 && !error && (
        <BrandSpecItem
          loading={loading}
          data={brandSnippets}
          title={
            discoveryType === "brand" ? "Brand Snippets" : "Product Snippets"
          }
        />
      )}
      {error && (
        <ErrorView
          title="Error fetching brand snippets"
          message={error}
          retry
        // onRetry={() => getBrandSnippets()}
        />
      )}
    </div>
  );
}
